module.exports = __webpack_public_path__ + "static/media/ml.204b0da4.svg";